(() => {
  const selector = 'herrera-cart-rewards';
  const threshold = 20000000;
  let timer, request, pending = false;
  const format = amount => new Intl.NumberFormat('es-CO', {style:'currency',currency:'COP',maximumFractionDigits:0}).format(amount / 100);
  const paint = (node, subtotal, currency) => {
    const eligibleCurrency = currency === 'COP';
    const missing = Math.max(0, threshold - subtotal);
    const text = !eligibleCurrency ? node.dataset.otherCurrency : missing > 0 ? node.dataset.shippingRemaining.replace('__AMOUNT__', format(missing)) : node.dataset.shippingAchieved;
    const message = node.querySelector('[data-hc-shipping]');
    if (message.textContent.trim() !== text) message.textContent = text;
    node.querySelector('[data-hc-shipping-progress]').value = eligibleCurrency ? Math.min(100, subtotal / threshold * 100) : 0;
  };
  async function refresh() {
    if (!document.querySelector(selector)) return;
    if (request) { pending = true; return; }
    request = true;
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + 'cart.js', {headers:{Accept:'application/json'},cache:'no-store'});
      if (!response.ok) return;
      const cart = await response.json();
      const retiredGifts = cart.items.filter(item => item.variant_id === 48614811238537 && item.properties?._herrera_obsequio);
      if (retiredGifts.length) {
        for (const item of retiredGifts) {
          const removal = await fetch(root + 'cart/change.js', {
            method:'POST', headers:{'Content-Type':'application/json'},
            body:JSON.stringify({id:item.key,quantity:0})
          });
          if (!removal.ok) return;
        }
        location.reload();
        return;
      }
      document.querySelectorAll(selector).forEach(node => {
        paint(node, cart.total_price, cart.currency);
      });
    } catch (_) {
    } finally {
      request = false;
      if (pending) { pending = false; queue(); }
    }
  }
  function queue() { clearTimeout(timer); timer = setTimeout(refresh, 250); }
  class CartRewards extends HTMLElement {
    connectedCallback() { const state = JSON.parse(this.querySelector('[data-hc-state]').textContent); paint(this, state.shipping, state.cart.currency); queue(); }
  }
  if (!customElements.get(selector)) customElements.define(selector, CartRewards);
  document.addEventListener('change', event => {
    if (event.target.closest('[data-cart-wrapper], [data-cart-items], form[action*="/cart"]')) queue();
  });
  document.addEventListener('visibilitychange', () => { if (!document.hidden) queue(); });
  new MutationObserver(records => {
    const changed = records.some(record => {
      const target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
      if (target?.closest(selector)) return false;
      return target?.closest('[data-cart-wrapper], [data-cart-items], [data-cart-count], [data-cart-total]') ||
        Array.from(record.addedNodes).some(node => node.nodeType === 1 && (node.matches?.(selector) || node.querySelector?.(selector)));
    });
    if (changed) queue();
  }).observe(document.body, {childList:true,subtree:true,characterData:true});
  queue();
})();
